import React, { useState, useEffect } from 'react';

import { Images } from 'assets/images';
import { SocialAuthButton } from 'components/Button/RectangleButton';
import { SocialLoginImage } from './styles';
import { getConfig } from 'functions/getConfig';
import services from 'api/services';
const { ConfigService } = services;

const SERVER_URL = getConfig().API_URL;
const LINKEDIN_CALLBACK_URL = `${SERVER_URL}/auth/callback/linkedIn`;

export default function SignInWithLinkedIn() {
  const state = JSON.stringify({ redirect: window.location.href });
  const [clientId, setClientId] = useState('');

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await ConfigService.getLinkedInClientId();
        setClientId(response);
      } catch (error) {
        console.log('error: ', error);
      }
    };
    fetch();
  }, []);

  return (
    <SocialAuthButton
      onClick={() => {
        localStorage.setItem('socialPlatform', 'LinkedIn');
        window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${clientId}&redirect_uri=${LINKEDIN_CALLBACK_URL}&scope=email%20profile%20openid&state=${state}`;
      }}
    >
      <SocialLoginImage src={Images.linkedIn} />
      Continue with LinkedIn
    </SocialAuthButton>
  );
}
